// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubMenu-module__submenu___oix7f {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0;
    z-index: 20; /* Lower than modal overlay z-index */
    pointer-events: none; /* Container doesn't catch mouse event */
}

    .SubMenu-module__submenu___oix7f ul {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        gap: 10px;
        background: transparent;
        border: none;
        pointer-events: auto; /* Menu items remain clickable by default */
    }

/* Backdrop component style */
.SubMenu-module__submenuBackdrop___GrDKe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px; 
    z-index: 9999; /* Just below the modal but above everything else */
    pointer-events: auto; 
    background: transparent;
}

/* when the modal is open */
.SubMenu-module__disabledMenu___NUPS1 {
    pointer-events: none !important;
    opacity: 0.7;
}

/* global style for body when modal is open */
body.modalOpen {
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/SubMenu/SubMenu.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,WAAW,EAAE,qCAAqC;IAClD,oBAAoB,EAAE,wCAAwC;AAClE;;IAEI;QACI,gBAAgB;QAChB,UAAU;QACV,SAAS;QACT,aAAa;QACb,SAAS;QACT,uBAAuB;QACvB,YAAY;QACZ,oBAAoB,EAAE,2CAA2C;IACrE;;AAEJ,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa,EAAE,mDAAmD;IAClE,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA,2BAA2B;AAC3B;IACI,+BAA+B;IAC/B,YAAY;AAChB;;AAEA,6CAA6C;AAC7C;IACI,gBAAgB;AACpB","sourcesContent":[".submenu {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: 0;\n    z-index: 20; /* Lower than modal overlay z-index */\n    pointer-events: none; /* Container doesn't catch mouse event */\n}\n\n    .submenu ul {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n        display: flex;\n        gap: 10px;\n        background: transparent;\n        border: none;\n        pointer-events: auto; /* Menu items remain clickable by default */\n    }\n\n/* Backdrop component style */\n.submenuBackdrop {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 50px; \n    z-index: 9999; /* Just below the modal but above everything else */\n    pointer-events: auto; \n    background: transparent;\n}\n\n/* when the modal is open */\n.disabledMenu {\n    pointer-events: none !important;\n    opacity: 0.7;\n}\n\n/* global style for body when modal is open */\n:global(body.modalOpen) {\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"submenu": `SubMenu-module__submenu___oix7f`,
	"submenuBackdrop": `SubMenu-module__submenuBackdrop___GrDKe`,
	"disabledMenu": `SubMenu-module__disabledMenu___NUPS1`
};
export default ___CSS_LOADER_EXPORT___;
